import { AuditTrailFeed } from '../../cmps/audit-trails/audit-trail-feed'

export const AwsAuditTrailsPage: React.FC = () => {
  return <div className="tablePageContainer">
    <div className="page-header">
      <p className="tableSubtitle">Audit history for AWS and backoffice actions.</p>
    </div>
    <AuditTrailFeed auditScope="global" hideCompanyFilter={true} />
  </div>
}
